<template>
  <vx-tooltip :text="$t('dial')" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      type="border"
      @click="process">
      <i class="c-icon-dial"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'
import Utils from '@/helpers/utils'

export default {
  name: 'CtiDial',
  props: {
    server: {
      required: true
    },
    isDisplay: {
      default: false
    }
  },
  computed: {
    phoneNumber () {
      return this.$store.getters.phoneNumber
    },
    extension () {
      return this.$store.getters.extension
    },
    userContext () {
      return this.$store.getters.userInfo.context
    },
    companyPermissions () {
      return this.$store.getters.userInfo.companyPermissions
    }
  },
  methods: {
    process () {
      if (this.isDisplay) {
        return
      }

      const useOutboundCallPopup = this.companyPermissions.find(function (permission) {
        return permission === 'company_can_use_outbound_call_popup'
      })

      if (useOutboundCallPopup) {
        Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound-popup', {})
        return
      }

      if (this.phoneNumber === null || this.phoneNumber.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Phone Number is Required.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      const data = {
        extension: this.extension,
        channel: this.phoneNumber,
        context: this.userContext
      }

      try {
        Cti.dial(this.server.domain, data)
        this.$vs.notify({
          title:'CTI Notice',
          text:`${this.phoneNumber} 으로 발신완료`,
          color:'danger',
          position:'top-right'
        })
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Dial Error',
          color:'danger',
          position:'top-right'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
